import { useEffect, useState } from "react";
import { getSiteTypeList } from "../services/configurationServices";


export const useSiteType = () => {

    const [siteTypes, setSiteTypes] = useState([]);
    const getSiteType = () => {
        try {
          let obj = {
            type: "SiteMode",
          };
          getSiteTypeList(obj).then((resp) => {
            if (resp != undefined) {
              if (resp.Status == "success") {
                setSiteTypes(resp.Data);
              } else {
                setSiteTypes([]);
              }
            }
          });
        } catch (error) {
          console.error(error);
        }
      };

    useEffect(() => {
        getSiteType();           
    }, []);

    return { siteTypes, setSiteTypes, getSiteType }
}

